import { message, Modal } from "antd";

export const showDanger = (msg) => message.error(msg);

export const showWarning = (msg) => message.warning(msg);

export const showSuccess = (msg) => message.success(msg);

/**
 * 获取uuid
 */
export function getUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        return (
            c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8"
        ).toString(16);
    });
}

export function showConfirm(msg) {
    return new Promise((resolve, reject) => {
        Modal.confirm({
            title: "提示",
            content: msg,
            okText: "确定",
            cancelText: "取消",
            onOk() {
                resolve(true);
            },
            onCancel() {
                resolve(false);
            },
        });
    });
}
